
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/pattern-type-only-breaking-changes-minor-versions",
      function () {
        return require("private-next-pages/blog/pattern-type-only-breaking-changes-minor-versions.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/pattern-type-only-breaking-changes-minor-versions"])
      });
    }
  